import { getLoggedOutTemplates } from "src/lib/actions";
import {
  getCategories,
  getProducts,
} from "src/clients/templatesBackendClient/client";

import { NavigationLink, MetaProduct } from "src/types";

export type ServiceRoute = {
  text: string;
  href?: string;
  onClick?: () => void;
};

//////////////////////////////////////////////////////////////////////////////
// ToSlug utils //////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const navigationLinkToSlug = (c: NavigationLink): string => c.slug;

//////////////////////////////////////////////////////////////////////////////
// ToPath utils //////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const serviceRootPath = `/templates`;

//////////////////////////////////////////////////////////////////////////////
// ToRoute utils /////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export const serviceRootRoute: ServiceRoute = {
  text: "Templates",
  href: serviceRootPath,
};

export const buildNavigationRoute = (
  navigationObject: NavigationLink,
  pathname: string | null,
  queryParamName?: "category" | "app",
): ServiceRoute => {
  if (!pathname) {
    return {
      text: navigationObject.name,
      href: `templates`,
    };
  }

  if (queryParamName) {
    return {
      text: navigationObject.name,
      href: `${pathname}?${queryParamName}=${navigationLinkToSlug(navigationObject)}`,
    };
  }
  const path = `${serviceRootPath}/${navigationLinkToSlug(navigationObject)}`;
  return { text: navigationObject.name, href: path };
};

export const productToRoute = async ({
  productSlug,
}: {
  productSlug: MetaProduct;
}): Promise<ServiceRoute> => {
  const response = await getProducts({
    where: {
      order: {
        exists: true,
      },
    },
    sort: "order",
    limit: 20,
  });
  const product = response?.docs?.find((p) => p.slug === productSlug);
  const path = `${serviceRootPath}/${product?.slug}`;
  return { text: product?.name ?? "", href: path };
};

//////////////////////////////////////////////////////////////////////////////
// getStaticPaths utils //////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

export type ParamWithSlug = { slug: string };

export async function getStaticPathsAsParamsWithSlugs(): Promise<
  ParamWithSlug[]
> {
  const categoriesResponse = await getCategories({
    where: {
      order: {
        exists: true,
      },
    },
    sort: "order",
    limit: 20,
  });
  const categories = categoriesResponse?.docs ?? [];

  const productsResponse = await getProducts({
    where: {
      order: {
        exists: true,
      },
    },
    sort: "order",
    limit: 20,
  });
  const products = productsResponse?.docs ?? [];

  const categoryParams =
    categories?.map((c) => ({
      slug: c.slug ?? "",
    })) ?? [];
  const productParams =
    products?.map((p) => ({
      slug: p?.slug ?? "",
    })) ?? [];

  return [...categoryParams, ...productParams];
}

export async function getStaticPathsAsParamsWithTemplateSlugs(): Promise<
  ParamWithSlug[]
> {
  const templates = await getLoggedOutTemplates({
    draftMode: false,
    select: {
      slug: true,
    },
  });
  const templateParams =
    templates?.map((t) => ({
      slug: t.slug,
    })) ?? [];

  return templateParams;
}
